<mat-form-field class="idba-lookup-autocomplete">
  <mat-label>{{ effectiveFieldLabel }}</mat-label>

  <input
    #autocompleteInput
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="autocomplete"
    [placeholder]="effectivePlaceholder"
    [errorStateMatcher]="errorStateMatcher"
    [readonly]="config.readonly ?? false"
    (blur)="handleBlur($event)"
    (keydown)="handleKeydown($event)"
  />

  @if (inputControl.value && !inputControl.disabled && !config.readonly) {
    <button
      mat-icon-button
      matSuffix
      type="button"
      tabindex="-1"
      aria-label="Limpar seleção"
      (click)="clearInput($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  } @else if (!inputControl.value && !inputControl.disabled && !config.readonly) {
    <button
      mat-icon-button
      matSuffix
      type="button"
      tabindex="-1"
      aria-label="Abrir opções"
      (click)="focusInput()"
    >
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  }

  @if (minimumSearchLengthMessage; as message) {
    <mat-hint>{{ message }}</mat-hint>
  }

  <mat-autocomplete
    #autocomplete="matAutocomplete"
    [displayWith]="displayValue"
    (optionSelected)="selectOption($event)"
  >
    @for (option of filteredOptions$ | async; track $index) {
      <mat-option [value]="option">{{ optionLabel(option) }}</mat-option>
    } @empty {
      @if (minimumSearchLengthMessage; as message) {
        <mat-option disabled>{{ message }}</mat-option>
      }
    }
  </mat-autocomplete>

  @if (config.validation?.showErrorMessage ?? true) {
    <mat-error
      i7-field-error-message
      [control]="validationControl"
      [fieldLabel]="effectiveFieldLabel"
      [messages]="validationMessages"
    ></mat-error>
  }
</mat-form-field>
